import '../style/Home.css';
import React from "react";
import { Container } from 'react-bootstrap';
import ReactPlayer from 'react-player';

const SimulationMovie = ({ simulation }) => {

    return (
        <Container className="container">
            {
                simulation.simulationMovieFilename &&
                    <ReactPlayer
                        url={'/api/download/trainee/' + simulation.id + '/MOVIE'}
                        controls={true}
                        className='border border-dark'>

                    </ReactPlayer>
            }

        </Container>
    );
}

export default SimulationMovie;